import DocumentService from '../../services/portefeuille/DocumentService'
import PortefeuilleService from '../../services/portefeuille/PortefeuilleService'

const Documents = {
    namespaced: true,
    state: {
        listeDocuments: [],
        count: 0,
        errors: {},
        loading: false
    },
    getters: {
        listeDocuments: state => state.listeDocuments,
        count: state => state.count,
        loading: state => state.loading
    },
    mutations: {
        setLoadingState(state, loading) {
            state.loading = loading
        },
        setDocuments(state, documents) {
            let docArray = []
            if (Array.isArray(documents)) {
                docArray = documents
            } else if (documents && documents.documentLink && Array.isArray(documents.documentLink)) {
                docArray = documents.documentLink
            }
            state.listeDocuments = docArray
            state.count = state.listeDocuments.length
            state.errors = {}
        },
        removeDocumentCommit(state, documentId) {
            state.listeDocuments = state.listeDocuments.filter(d => d._id !== documentId)
            state.count = state.listeDocuments.length
        },
        setErrors(state, error) {
            state.errors = error
        }
    },
    actions: {
        async fetchDocuments({commit}) {
            commit('setLoadingState', true)
            try {
                const response = await PortefeuilleService.getPortefeuille()
                const documents = (response.data.portefeuille && response.data.portefeuille.documents) || []
                commit('setDocuments', documents)
                return documents
            } catch (error) {
                console.error('Erreur chargement documents:', error)
                commit('setErrors', error)
                throw error
            } finally {
                commit('setLoadingState', false)
            }
        },
        async addDocument({commit, dispatch}, documentData) {
            try {
                await DocumentService.uploadDocument(documentData)
                const documents = await dispatch('fetchDocuments')
                return documents[0] || null
            } catch (error) {
                console.error('Erreur upload document:', error)
                commit('setErrors', error)
                throw error
            }
        },
        async updateDocument({commit, dispatch}, {id, documentData}) {
            try {
                await DocumentService.updateDocument(id, documentData)
                const documents = await dispatch('fetchDocuments')
                return documents.find(document => document._id === id) || null
            } catch (error) {
                console.error('Erreur modification document:', error)
                commit('setErrors', error)
                throw error
            }
        },
        async deleteDocument({commit, dispatch, state}, documentId) {
            try {
                await DocumentService.deleteDocument(documentId)
                await dispatch('fetchDocuments')

                const stillExists = state.listeDocuments.some(document => document._id === documentId)
                if (stillExists) {
                    throw new Error('Document deletion was not reflected in the refreshed list')
                }

                commit('removeDocumentCommit', documentId)
            } catch (error) {
                console.error('Erreur suppression document:', error)
                commit('setErrors', error)
                throw error
            }
        }
    }
}

export default Documents
